<template>
    <div id="print">
        <b-modal id="modal-1" title="見積り一覧" centered size="xl" v-model="show">
            <div id="print_area">
                <div class="price_header">
                    <img id="print_svg" src="../assets/images/header_title.png" alt="" width="280" height="65">
                </div>
                <b-table id="print_table" striped responsive :items="items" style="white-space:pre-wrap; word-wrap:break-word;">
                    <span slot="スタイル" slot-scope="data" v-html="data.value"></span>
                    <span slot="縫製仕様" slot-scope="data" v-html="data.value"></span>
                    <span slot="操  作" slot-scope="data" v-html="data.value" v-on:click="deleteRow(data.index)"></span>
                </b-table>
            </div>
            <div slot="modal-footer" class="w-100">
<!--                <p class="float-left">-->
<!--                    <b-button-->
<!--                            v-on:click="save_image()"-->
<!--                            variant="success"-->
<!--                    >画像ダウンロード</b-button>-->
<!--                </p>-->
                <p class="float-left">
                    <b-button
                            v-on:click="makePDF()"
                            variant="success"
                    >PDFダウンロード</b-button>
                    <p class="caution-text">&nbsp;&nbsp;※ブラウザの拡大率100%とOSの拡大率100%に設定していない場合
                        <br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;印刷内容が途中で切れる場合があります</p>
                </p>
                <p>
                <b-button
                        variant=""
                        class="float-right"
                        @click="show=false"
                >
                    閉じる
                </b-button></p>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import html2canvas from 'html2canvas'
    import jsPDF from 'jspdf'
    export default {
        name: 'PRINT',
        computed: {
            group1_1 : {
                get: function () {
                    if(this.$store.state.step2_data.style_selected1_id !== ''){
                        return this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected1_id].group1
                    }
                    return ''
                },
            },
            group2_1 : {
                get: function () {
                    if(this.$store.state.step2_data.style_selected2_id){
                        return this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected2_id].group1
                    }
                    return ''
                },
            },
            group2: {
                get: function () {
                    if(this.$store.state.step2_data.style_selected2_id){
                        return this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected2_id].group2
                    }else{
                        return ''
                    }
                },
            },
            style_selected1_name: {
                get: function () {
                    return this.$store.state.step2_data.style_selected1_name
                },
            },
            style_selected2_name: {
                get: function () {
                    return this.$store.state.step2_data.style_selected2_name
                },
            },
            item_data: {
                get: function () {
                    if(
                        this.$store.state.step1_data.item_number &&
                        this.$store.state.xlsx_data.item_data &&
                        typeof(this.$store.state.xlsx_data.item_data['TT'+this.$store.state.step1_data.item_number]) !=='undefined'
                    ){
                        return this.$store.state.xlsx_data.item_data['TT'+this.$store.state.step1_data.item_number]
                    }
                    return ''
                },
            },
        },
        data() {
            return {
                show: false,
                items:[]
            }
        },
        created : function () {
            this.loadItem()
        },
        methods: {
            add_item:function(){
                this.loadItem()
                let total_price = this.$store.state.price_data.total_price
                if(total_price === '製作不可のサイズです' || total_price ==='価格についてはお問い合わせください'){
                    total_price = '-'
                }
                this.items.push(
                    {
                        '品  番':'TT'+this.$store.state.step1_data.item_number,
                        'スタイル':
                            "<div class='m-0'>"+((this.$store.state.step2_data.style_selected1_id !== '') ? this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected1_id].name+"\n" : '') +"</div>"+
                            "<div class='m-0'>"+((this.$store.state.step2_data.style_selected2_id !== '') ? this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected2_id].name : '')+"</div>",
                        '縫製仕様' :
                           this.cleateStep3Data(),
                        '数量':this.$store.state.step4_data.set_number,
                        '施工場所':this.$store.state.step5_data.room_selected,
                        '価  格':total_price+' 円',
                        '操  作':'<button class="btn btn-danger">削除</button>'
                    }
                )
                //他のカタログも入れるためローカルストレージに
                localStorage.setItem('OSPriceSystem', JSON.stringify(this.items))
            },
            loadItem:function(){
                if(JSON.parse(localStorage.getItem('OSPriceSystem'))){
                    this.items = JSON.parse(localStorage.getItem('OSPriceSystem'))
                }
            },
            cleateStep3Data(){
                const width_size  = (this.$store.state.step3_data.width_size != '')?'巾'+this.$store.state.step3_data.width_size+'cm':''
                const height_size = (this.$store.state.step3_data.height_size != '')?'　丈'+this.$store.state.step3_data.height_size+'cm':''
                let group1_1,group2_1
                if(this.$store.state.step2_data.style_selected1_id !==''){
                    group1_1 = this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected1_id].group1
                }
                let group2 = ''
                if(this.$store.state.step2_data.style_selected2_id !==''){
                    group2   = this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected2_id].group2
                    group2_1 = this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected2_id].group1
                }
                let item_data = ''
                if(
                    this.$store.state.step1_data.item_number &&
                    this.$store.state.xlsx_data.item_data &&
                    typeof(this.$store.state.xlsx_data.item_data['TT'+this.$store.state.step1_data.item_number]) !=='undefined'
                ){
                    item_data = this.$store.state.xlsx_data.item_data['TT'+this.$store.state.step1_data.item_number]
                }

                let style_name = ''
                let price_note = ''
                let result_data =
                    "<table class='org-table_not_stripe org-height' style='height: 108px;display: inline-block; font-size:0.9rem;'>"
                    if((group2_1 || group1_1) && group2_1 !== 'ベッドスプレッド' && group1_1 !=='クッション') {
                        result_data +="<tr class='p-0'><td class='p-0' colspan='2'>" + width_size + height_size + "</td></tr>"
                    }
                    if(this.isset(this.$store.state.step3_data.hida) && group1_1==='カーテン'){result_data +=
                        "<tr class='p-0'><td class='p-0 pr-3'>倍率・ヒダスタイル"+"</td><td class='p-0'>"+this.$store.state.step3_data.hida+"</td></tr>"
                    }
                    if(this.isset(this.$store.state.step3_data.ura) && (group1_1=='カーテン' || group2=='ローマンシェード シングル') && item_data && item_data['ドレープ/レース'] === 'ドレープ')
                    {
                        result_data += "<tr class='p-0'><td class='p-0 pr-3'>裏地</td><td class='p-0'>"+this.$store.state.step3_data.ura+"</td></tr>"
                    }
                    if(this.isset(this.$store.state.step3_data.open) && this.group1_1==='カーテン'){result_data +=
                        "<tr class='p-0'><td class='p-0 pr-3'>開閉方法</td><td class='p-0'>"+this.$store.state.step3_data.open+'</td></tr>'
                    }
                    if(
                        this.isset(this.$store.state.step3_data.suso) && this.group1_1==='カーテン'
                    ){
                        let suso_option = []
                        if(this.$store.state.step2_data.style_selected2_id !==''){
                            suso_option=this.$store.state.xlsx_select_data.select_data['カーテン'][this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected2_id].name]['裾形状を選ぶ↓ヨコ使いレース生地のみ'].option
                        }
                        else if(this.$store.state.step2_data.style_selected1_id !==''){
                            suso_option=this.$store.state.xlsx_select_data.select_data['カーテン'][this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected1_id].name]['裾形状を選ぶ↓ヨコ使いレース生地のみ'].option
                        }
                        if(suso_option.length>1){
                            result_data +="<tr class='p-0'><td class='p-0 pr-3'>裾形状</td><td class='p-0'>"+this.$store.state.step3_data.suso+'</td></tr>'
                        }
                    }
                    if(this.isset(this.$store.state.step3_data.mecha)){result_data +=
                        "<tr class='p-0'><td class='p-0 pr-3'>メカ</td><td class='p-0'>"+this.$store.state.step3_data.mecha+'</td></tr>'
                    }
                    if(this.isset(this.$store.state.step3_data.kurumi)){result_data +=
                        "<tr class='p-0'><td class='p-0 pr-3'>仕様</td><td class='p-0'>"+this.$store.state.step3_data.kurumi+'</td></tr>'
                    }
                    if(this.isset(this.$store.state.step3_data.cloth)){result_data +=
                        "<tr class='p-0'><td class='p-0 pr-3'>クロス</td><td class='p-0'>"+this.$store.state.step3_data.cloth+'</td></tr>'
                    }
                    if(this.isset(this.$store.state.step3_data.trim)){result_data +=
                        "<tr class='p-0'><td class='p-0 pr-3'>トリム品番</td><td class='p-0'>"+this.$store.state.step3_data.trim+'</td></tr>'
                    }
                    if(this.isset(this.$store.state.step3_data.fringe)){result_data +=
                        "<tr class='p-0'><td class='p-0 pr-3'>フリンジ品番</td><td class='p-0'>"+this.$store.state.step3_data.fringe+'</td></tr>'
                    }
                    if(this.isset(this.$store.state.step3_data.deco_fringe)){result_data +=
                        "<tr class='p-0'><td class='p-0 pr-3'>フリンジ品番</td><td class='p-0'>"+this.$store.state.step3_data.deco_fringe+'</td></tr>'
                    }
                    if(this.isset(this.$store.state.step3_data.window_number)){
                        result_data += "<tr class='p-0'><td class='p-0 pr-3'>台数</td><td class='p-0'>"+this.$store.state.step3_data.window_number+'</td></tr>'
                    }
                    if(this.isset(this.$store.state.step3_data.return_type)){result_data +=
                        "<tr class='p-0'><td class='p-0 pr-3'>リターン</td><td class='p-0'>"+this.$store.state.step3_data.return_type+'</td></tr>'
                    }
                    if(this.isset(this.$store.state.step1_data.atomaku_number) && group2=='ローマンシェード ツイン') {
                        result_data += "<tr class='p-0'><td class='p-0 pr-3'>後幕品番</td><td class='p-0'>TT"+this.$store.state.step1_data.atomaku_number+'</td></tr>'
                    }
                    if(this.isset(this.$store.state.step3_data.atomaku_style) && group2=='ローマンシェード ツイン') {
                        result_data += "<tr class='p-0'><td class='p-0 pr-3'>後幕スタイル</td><td class='p-0'>"+this.$store.state.step3_data.atomaku_style+'</td></tr>'
                    }
                    if(this.isset(this.$store.state.step3_data.quilting_type)){result_data +=
                        "<tr class='p-0'><td class='p-0 pr-3' style='font-size: 0.8rem;'>スタンダード/キルティング</td><td class='p-0'>"+this.$store.state.step3_data.quilting_type+'</td></tr>'
                    }
                    if(this.isset(this.$store.state.step3_data.finish_size)){result_data +=
                        "<tr class='p-0'><td class='p-0 pr-3'>仕上りサイズ</td><td class='p-0'>"+this.$store.state.step3_data.finish_size+'</td></tr>'
                    }
                    if(this.isset(this.$store.state.step3_data.bed_size)){result_data +=
                        "<tr class='p-0'><td class='p-0 pr-3'>仕上りサイズ</td><td class='p-0'>"+this.$store.state.step3_data.bed_size+'</td></tr>'
                    }
                    if(this.isset(this.$store.state.step3_data.select_size) && group1_1=='クッション'){
                        result_data +="<tr class='p-0'><td class='p-0 pr-3'>仕上りサイズ</td><td class='p-0'>"+this.$store.state.step3_data.select_size+'</td></tr>'
                    }
                    //商品金額注釈
                    if(group2==='ローマンシェード シングル' || group2==='ローマンシェード ツイン'){
                        price_note = 'シェード本体価格に配送諸経費として別途3,000円を加算ください'
                        if(this.$store.state.step2_data.style_selected1_id !== ''){
                            style_name = this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected1_id].name
                        }else if(this.$store.state.step2_data.style_selected2_id !==''){
                            style_name = this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected2_id].name
                        }
                        if(style_name==='プレーン小窓'){
                            price_note = 'シェード本体価格に配送諸経費として別途1台につき3,000円を加算ください'
                        }
                        result_data += "<tr class='p-0'><td  colspan='2' class='p-0 pr-3' style='font-size: 0.78rem;'>"+price_note+'</td></tr>'
                    }
                    result_data +=
                    "</table>"
                if(this.$store.state.price_data.total_price === '製作不可のサイズです' || this.$store.state.price_data.total_price ==='価格についてはお問い合わせください'){
                    result_data +='<br><span style="font-size: 0.8rem;">※'+this.$store.state.price_data.total_price+'</span>'
                }
                return result_data
            },
            deleteRow:function(val){
                this.items.splice(val, 1)
                //他のカタログも入れるためローカルストレージに
                localStorage.setItem('OSPriceSystem', JSON.stringify(this.items))
            },
            /**
             *  値の有無をチェック
             *  phpのisset()に相当
             *  @param  data    値
             *  @return         true / false
             *
             */
            isset : function(data){
                if(data === "" || data === null || data === undefined){
                    return false;
                }else{
                    return true;
                }
            },
            /**
             * PNG保存
             * 保存用の画面（選択ラグ）を表示
             * まずは画面をコピーしてcanvasに入れる→saveImage2へ
             */
            save_image:function (){
                html2canvas(document.querySelector("#print_area")).then(canvas => {
                    const canvas_img = document.body.appendChild(canvas)
                    this.saveImage2(canvas);
                    canvas_img.remove()
                });
            },
            /**
             * 拡大率チェック
             */
            check_zoom:function(){
                let winwidth = window.outerWidth;
                let bodywidth = document.querySelector('#check_rate').clientWidth;
                let zoom_rate = Math.round((winwidth / bodywidth) * 100);
                //console.log(zoom_rate)
                //100%のみ許可
                if (zoom_rate <= 95) {
                    alert('ブラウザの拡大率が100％ではありません。Ctrl + 0でブラウザの拡大率を初期化してください');
                    return false;
                } else if (zoom_rate >= 105) {
                    alert('ブラウザの拡大率が100％ではありません。Ctrl + 0でブラウザの拡大率を初期化してください');
                    return false;
                } else {
                    return true;
                }
            },
            /**
             * PDFの保存 html2canvas → jspdf
             *
             */
            makePDF:function(){
                if(!this.check_zoom()){
                    alert('画面拡大率に問題があったため印刷を中止しました。');
                    return false
                }
                let quotes    = document.getElementById("print_area");
                let saveWidth = quotes.clientWidth;
                //要素を強制的に1106pxに設定(1920pxで見た時のprint_areaの幅)
                quotes.style.width = '1106px';
                html2canvas(quotes).then(canvas => {
                    let pdf = new jsPDF('p', 'pt', 'a4');

                    //品番の取得…ファイル名の作成
                    const file_name = '価格データ.pdf'

                    for (var i = 0; i <= quotes.clientHeight/1620; i++) {
                        //設定関連
                        let srcImg   = canvas;
                        let sX       = 0;
                        let sY       = 1600*i;
                        let sWidth   = quotes.clientWidth;
                        let sHeight  = 1600;
                        let dX       = 0;
                        let dY       = 0;
                        let dWidth   = quotes.clientWidth;
                        let dHeight  = 1600;
                        let setHeight= quotes.clientHeight;
                        let pdf_margin = 40;
                        //IE専用
                        if(this.isIEBrowser()) {
                            pdf_margin = 40;
                            sHeight  = quotes.clientHeight;
                            dHeight  = quotes.clientHeight;
                            setHeight= 1600;
                        }

                        //canvasの生成
                        window.onePageCanvas = document.createElement("canvas");
                        onePageCanvas.setAttribute('width', 1106);
                        onePageCanvas.setAttribute('height', setHeight);

                        let ctx = onePageCanvas.getContext('2d');
                        //イメージの書き出し
                        ctx.drawImage(srcImg,sX,sY,sWidth,sHeight,dX,dY,dWidth,dHeight);

                        let canvasDataURL = onePageCanvas.toDataURL("image/png", 1.0);

                        //PDFに書き出す際のサイズ設定
                        let width         = pdf.internal.pageSize.width - pdf_margin;
                        let height        = onePageCanvas.clientHeight;

                        //改ページ処理
                        if (i > 0) {
                            pdf.addPage(595, 1120); //8.5" x 11" in pts (in*72)
                        }
                        //書き出し
                        pdf.setPage(i+1);
                        pdf.addImage(canvasDataURL, 'PNG', 20, 20, width, height);
                    }
                    //要素の幅を戻す
                    quotes.style.width = 'auto';
                    //PDFダウンロード
                    pdf.save(file_name);
                });
            },
            /**
             * 使用ブラウザを判定してbool値を返す
             * IEの場合 TRUE
             */
            isIEBrowser:function(){
            let ieBrowser;
            let ua = window.navigator.userAgent;
            let msie = ua.indexOf("MSIE ");
                if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) // Internet Explorer
                {
                    ieBrowser = true;
                }
                else  //Other browser
                {
                    //console.log('Other Browser');
                    ieBrowser = false;
                }
            return ieBrowser;
            },
            /**
             * 保存処理 画面をコピーしたcanvasを作成し、それをPNG保存
             * @param _canvas
             */
            saveImage2:function (_canvas) {
                const h = _canvas.toDataURL("image/png").split(",")
                const b = h[0].split(":")[1].split(";")[0]
                const j = atob(h[1])
                const k = new Uint8Array(j.length)
                for (let i = 0; i < j.length; i++) {
                    k[i] = j.charCodeAt(i)
                }
                const e = new Blob([k], {type: b})
                const file_name = this.$store.state.step1_data.item_number+'_価格データ.png'

                if (window.navigator.msSaveBlob) {
                    window.navigator.msSaveBlob(e, file_name)
                } else {
                    const event = document.createEvent("MouseEvents")
                    event.initMouseEvent("click", true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
                    const a = document.createElementNS("http://www.w3.org/1999/xhtml", "a")
                    a.href = (window.URL || window.webkitURL).createObjectURL(e)
                    a.download = file_name
                    a.dispatchEvent(event)
                }
            },
        }
    }
</script>

<style scoped>

</style>